import { IconProps } from '../../../../services/utils/types/globals';

SubstractIcon.defaultProps = {
  size: '12',
  color: '#EB5252',
  rotate: '0',
};
export default function SubstractIcon(props: IconProps) {
  return (
    <svg
      width={props.size}
      height={props.size}
      transform={`rotate(${props.rotate})`}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM9 3.94482C8.58526 3.94482 8.25 4.3639 8.25 4.88232V10.5073C8.25 11.0257 8.58526 11.4448 9 11.4448C9.41474 11.4448 9.75 11.0248 9.75 10.5073V4.88232C9.75 4.3639 9.41477 3.94482 9 3.94482ZM9.68998 13.0045C9.65247 12.907 9.59994 12.8244 9.53239 12.7569C9.52266 12.7491 9.51293 12.7408 9.50307 12.7324C9.47491 12.7084 9.44567 12.6835 9.41235 12.6669C9.37484 12.6369 9.32981 12.6151 9.28477 12.5993C9.23974 12.5761 9.19474 12.5618 9.14221 12.5543C8.90282 12.5018 8.63944 12.585 8.46761 12.7569C8.40006 12.8244 8.34756 12.907 8.31002 13.0045C8.27252 13.0946 8.25 13.1921 8.25 13.2897C8.25 13.3873 8.27252 13.4848 8.31002 13.5749C8.34753 13.6649 8.40006 13.7474 8.46761 13.8225C8.54265 13.89 8.62519 13.9425 8.71523 13.9801C8.80526 14.0176 8.90282 14.0401 9.00039 14.0401C9.09795 14.0401 9.19474 14.0176 9.28477 13.9801C9.37481 13.9426 9.45661 13.89 9.53239 13.8225C9.59994 13.7474 9.65244 13.6649 9.68998 13.5749C9.72748 13.4848 9.75 13.3873 9.75 13.2897C9.75 13.1921 9.72748 13.0946 9.68998 13.0045Z"
        fill={props.color}
      />
    </svg>
  );
}
